// extracted by mini-css-extract-plugin
module.exports = {"profile_name":"profile-card_profile_name__3eRun","card":"profile-card_card__bl-f1"};